module.exports = __webpack_public_path__ + "static/media/il.23c41cbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/il.png
// module id = 1881
// module chunks = 0